export default [{
  path:'/weightRecord',
  name:'weightRecord',
  component: () => import('./views/weightRecord.vue'),
  meta:{
    title:'称重记录',
    permissionCode: '2669'
  }
},
  {
    path:'/orderRecord',
    name:'orderRecord',
    component: () => import('./views/orderRecord.vue'),
    meta:{
      title:'订单记录',
      permissionCode: '2670'
    }
  }
]
